import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import moment from "moment";

import { useSpinner } from "../../../context/SpinnerContext";
import SpinnerButton from "../../../Componet/Button/SpinnerButton";

import HerosectionHeader from "../../../Componet/Herosection/HerosectionHeader";
import { InspectorStatus } from '../../../store/Utility/Status';
import EmptyDataResult from "../../../Componet/EmptyDataResult";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAuth from "../../../hooks/useAuth";
import { Roles } from "../../../store/Utility/Utility";

const AwaitingInspectorList = () => {
    let { filter } = useParams();
    const [inspectors, setInspectors] = useState(null);
    const [loading, setLoading] = useState(false);
    const { showLoader, hideLoader } = useSpinner();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const [nameStartWith, setNameStartWith] = useState(filter);

    const fetchInspectors = async (e) => {
        setLoading(true);
        await axiosPrivate.get(`v1/inspector/awaiting-inspector`,
            {
                params: { firstName: nameStartWith }
            }).then(res => {
                setLoading(false);
                setInspectors(res?.data?.data);
            });
    };


    const onSendReminder = async (id) => {
        showLoader();
        await axiosPrivate.post(`v1/inspector/send-reminder`, JSON.stringify(id)).then(res => {
            fetchInspectors();
            hideLoader();
        }).catch(error => {
            hideLoader();
        });
    }

    return (<>
        <HerosectionHeader name={"Awaiting Inspectors"} />
        <div className="container">
            <Row>
                <Col md={6}>

                </Col>
                <Col md={2}><div className="mt-5 d-flex align-items-center"><span>Result: {inspectors?.length}</span></div></Col>
                <Col md={2}><div className="mt-4 d-flex align-items-center"><input type="text" value={nameStartWith} onChange={(e) => setNameStartWith(e.target.value)} className="form-control" name="nameStartsWith" placeholder="Name" /></div></Col>
                <Col md={2}>
                    <div className="mt-5 d-flex">
                        <SpinnerButton type="button" className="btn btn-primary btn-sm" loading={loading} onClick={fetchInspectors} text="Search" />
                    </div>
                </Col>
            </Row>
            <div className="row">
                <div className="col">
                    {(inspectors && inspectors.length > 0) ?
                        inspectors.map((item, index) => ((
                            <div className="card bg-transparent flex-md-row align-items-center p-md-0 3 mt-3 mb-3">
                                <div className="col-md-2">
                                    <div className="bg-primary p-2 d-inline-block rounded m-4">
                                        <div className="f-icon-m text-white">

                                            <i className={item.status == InspectorStatus.Approved ? "la la-user-check" :
                                                item.status == InspectorStatus.Applicant ? "la la-user-clock" :
                                                    item.status == InspectorStatus.AwaitingContract ? "la la-user-edit" :
                                                        item.status == InspectorStatus.Suspended ? "la la-user-minus" : "la la-user"}></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body col-md-5">
                                    <div>
                                        <div className="d-inline-block bg-light text-center rounded">
                                            {/* <span class="text-primary">{VehicleTypes.find(t => t.id == job.vehicleType).name}</span> */}

                                        </div>
                                        <span>{item.state} / {item.city} / {item.zipCode} / SZC:{item.serviceZipCode}</span>

                                    </div>
                                    <h2 className="h5 my-2">
                                        <a className="link-title">{item.firstName} {item.lastName}</a>
                                    </h2>
                                    <ul className="list-inline mb-0">
                                        <li className="list-inline-item pe-3">
                                            <a className="list-group-item-action">
                                                <i className="lar la-calendar-info ms-1 text-primary ic-1x"></i>
                                                {moment(item.createdDate).format('MM.DD.YYYY')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-3">

                                    <div className="col"> <div className="d-inline-block text-center rounded">
                                        Contract sent on: </div>
                                        <span> {item.lastReminderSendDate ? moment(item.lastReminderSendDate).format('MM.DD.YYYY') : 'N/A'}</span>
                                    </div>

                                    <div className="col"> <div className="d-inline-block mt-2 text-center rounded">
                                        Email: </div>
                                        <span> {item.email}</span>
                                    </div>

                                    <div className="col"> <div className="d-inline-block mt-2 text-center rounded">
                                        Phone: </div>
                                        <span> {item.phone}</span>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="col">

                                        <span>Reminder Count: {item.reminderCount}</span>
                                        {(item.status == 2 && auth?.user?.roles?.find(role => [Roles.Admin, Roles.Employee].includes(role)))
                                            && <SpinnerButton type="button" className="btn btn-secondary" loading={loading} onClick={() => onSendReminder(item.id)} text="Send Reminder" />}
                                    </div>

                                </div>
                            </div>))) : <div> <EmptyDataResult message="There is no data to display" /></div>
                    }

                </div>
            </div>
        </div>
    </>);

}

export default AwaitingInspectorList;